import { clearAllPersistentFilters } from "../../components/Common/usePersistentFilters";
import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import logo from "../../../images/favicon.png";
import newlogo from "../../../images/logo-full.png";

const NavHader = () => {
 const [toggle, setToggle] = useState(false);
 const [isMobile, setIsMobile] = useState(false);
 const { menuToggle, setMenuToggle } = useContext(ThemeContext);

 useEffect(() => {
 const checkMobile = () => setIsMobile(window.innerWidth <= 991);
 checkMobile();
 window.addEventListener("resize", checkMobile);
 return () => window.removeEventListener("resize", checkMobile);
 }, []);

 const handleToggle = () => {
 setToggle(!toggle);
 setMenuToggle(!menuToggle);
 };

 // Logo logic:
 // When menuToggle is TRUE, sidebar is COLLAPSED (small logo should show)
 // When menuToggle is FALSE, sidebar is OPEN (large logo should show)
 const showSmallLogo = isMobile || menuToggle;

 return (
 <div className="nav-header shadow-sm">
 <Link to="/dashboard" onClick={clearAllPersistentFilters} className="brand-logo d-flex align-items-center justify-content-center" style={{ padding: "10px 15px", height: "100%", width: "100%" }}>
 {showSmallLogo ? (
 <img
 src={logo}
 alt="Favicon"
 className="logo-abbr"
 style={{ width: "60px", height: "60px", objectFit: "contain" }}
 />
 ) : (
 <div className="logo-full-wrapper d-flex align-items-center justify-content-center w-100">
 <div style={{ background: '#ffffff', padding: '6px 10px', borderRadius: '6px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
 <img
 src={newlogo}
 alt="Full Logo"
 className="logo-full"
 style={{ height: "60px", maxWidth: "200px", objectFit: "contain", display: "block" }}
 />
 </div>
 </div>
 )}
 </Link>

 <div
 className="nav-control"
 onClick={handleToggle}
 style={{ cursor: "pointer" }}
 >
 <div className={`hamburger ${!menuToggle ? "is-active" : ""}`}>
 <span className="line"></span>
 <span className="line"></span>
 <span className="line"></span>
 </div>
 </div>
 </div>
 );
};

export default NavHader;
